import React from "react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import { useTranslation } from "react-i18next";

const Statistics = () => {
  const { t } = useTranslation("statistics");
  const { ref, inView } = useInView({
    triggerOnce: true, // Trigger the animation once
    threshold: 0.2, // Trigger when 20% of the component is in view
  });

  const statsData = [
    {
      value: parseInt(t("statistics.diamondsPolished.value")),
      suffix: t("statistics.diamondsPolished.suffix"),
      label: t("statistics.diamondsPolished.label"),
    },
    {
      value: parseInt(t("statistics.diamondsGrown.value")),
      suffix: t("statistics.diamondsGrown.suffix"),
      label: t("statistics.diamondsGrown.label"),
    },
    {
      value: parseInt(t("statistics.skilledProfessionals.value")),
      suffix: t("statistics.skilledProfessionals.suffix"),
      label: t("statistics.skilledProfessionals.label"),
    },
    {
      value: parseInt(t("statistics.happyCustomers.value")),
      suffix: t("statistics.happyCustomers.suffix"),
      label: t("statistics.happyCustomers.label"),
    },
  ];

  return (
    <div className="py-16 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div
          className="grid grid-cols-1 md:grid-cols-4 gap-6 text-center"
          ref={ref}
          data-aos="fade-down"
        >
          {statsData.map((stat, index) => (
            <div
              key={index}
              className="bg-[#1e1e1e] rounded-lg py-8 px-4 flex flex-col items-center"
            >
              {inView && (
                <div className="text-4xl font-bold">
                  <CountUp
                    start={0}
                    end={stat.value}
                    duration={3}
                    suffix={stat.suffix}
                  />
                </div>
              )}
              <h3 className="text-lg font-medium mt-2">{stat.label}</h3>
            </div>
          ))}
        </div>
      </div>
      {/* Quote Section */}
      <div className="mt-10 text-center max-w-3xl mx-auto text-black">
        <p>{t("statistics.quote")}</p>
      </div>
    </div>
  );
};

export default Statistics;
